var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9125 1.1865C93.316 0.40558 88.6624 0.00870964 84 0C37.59 0 0 37.59 0 84C0 101.818 5.60175 118.283 15.015 131.938C20.79 123.454 34.1092 117.6 49.5495 117.6C60.1545 117.6 69.7462 120.398 76.6185 124.898L97.9125 1.1865ZM142.548 23.8403C157.054 55.9178 144.328 73.0537 144.328 73.0537C134.484 43.4438 105.977 39.1178 105.977 39.1178C105.977 39.1178 87.2235 140.17 87.2235 141.44C87.2235 152.387 75.6 161.637 59.8185 164.435C67.6622 166.795 75.8089 167.996 84 168C130.41 168 168 130.41 168 84C168 60.4118 158.24 39.1125 142.548 23.8403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.41cc2d074259b0c9d83a53bab013d96c.svg";
export { ForwardRef as ReactComponent };